/**
 * Resolve Scratch static asset base path for production FTP/Apache deployments.
 * Absolute paths from the site root are more reliable than "./" in Blockly media URLs.
 * @param {string} [basePath] - optional override from GUI props
 * @returns {string} base path ending with "/"
 */
export const resolveScratchBasePath = (basePath = './') => {
    if (basePath && basePath !== './') {
        return basePath.endsWith('/') ? basePath : `${basePath}/`;
    }
    if (typeof window !== 'undefined') {
        const custom = window.__SCRATCH_BASE_PATH;
        if (custom) {
            const normalized = String(custom);
            return normalized.endsWith('/') ? normalized : `${normalized}/`;
        }
        return '/';
    }
    return './';
};

/**
 * @param {string} suffix - path after static/, e.g. "blocks-media/default/"
 * @param {string} [basePath] - optional override from GUI props
 * @returns {string}
 */
export const resolveScratchStaticPath = (suffix, basePath = './') =>
    `${resolveScratchBasePath(basePath)}static/${suffix}`;
